import gql from 'graphql-tag';

export const all = gql`{
    countries {
        id
        name
        isoCode
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/queries/country.js